module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r-table"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('table', {
    staticClass: "tb"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("账号")]), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('th', [_vm._v("等级")]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config_info.finance_salary_status === '1'),
      expression: "config_info.finance_salary_status === '1'"
    }]
  }, [_vm._v("等级礼金")]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config_info.week_salary_status === '1'),
      expression: "config_info.week_salary_status === '1'"
    }]
  }, [_vm._v("周俸禄")]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config_info.month_salary_status === '1'),
      expression: "config_info.month_salary_status === '1'"
    }]
  }, [_vm._v("月俸禄")]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend === '1') ? _c('th', [_vm._v("VIP等级")]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend === '1') ? _c('th', [_vm._v("电子等级")]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend === '1') ? _c('th', [_vm._v("真人等级")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("标价")]), _vm._v(" "), (_vm.type === 1) ? _c('th', [_vm._v("出价")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("成交价格")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("操作")])]), _vm._v(" "), (!_vm.list.length) ? _c('tr', {
    staticClass: "tr_sec"
  }, [(_vm.type === 1) ? _c('td', {
    attrs: {
      "colspan": "10",
      "rowspan": "",
      "headers": ""
    }
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('td', {
    attrs: {
      "colspan": "9",
      "rowspan": "",
      "headers": ""
    }
  }, [_vm._v("暂无数据")]) : _vm._e()]) : _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.account))]), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('td', [_vm._v(_vm._s(item.e_level))]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.config_info.finance_salary_status === '1'),
        expression: "config_info.finance_salary_status === '1'"
      }]
    }, [_vm._v(_vm._s(item.e_up_reward))]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.config_info.week_salary_status === '1'),
        expression: "config_info.week_salary_status === '1'"
      }]
    }, [_vm._v(_vm._s(item.e_week_reward))]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend !== '1') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.config_info.month_salary_status === '1'),
        expression: "config_info.month_salary_status === '1'"
      }]
    }, [_vm._v(_vm._s(item.e_month_reward))]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend === '1') ? _c('td', [_vm._v(_vm._s(item.vip_level))]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend === '1') ? _c('td', [_vm._v(_vm._s(item.e_level))]) : _vm._e(), _vm._v(" "), (_vm.config_info.sale_extend === '1') ? _c('td', [_vm._v(_vm._s(item.r_level))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sale_price))]), _vm._v(" "), (_vm.type === 1) ? _c('td', [_vm._v(_vm._s(item.buy_price))]) : _vm._e(), _vm._v(" "), (_vm.type === 1) ? _c('td', [(item.status == 4) ? [_vm._v("\n            " + _vm._s(item.deal_price) + "\n          ")] : [_vm._v("-")]], 2) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('td', [(item.status == 3) ? [_vm._v("\n            " + _vm._s(item.deal_price) + "\n          ")] : [_vm._v("-")]], 2) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatBuyStatus(item.status)))]), _vm._v(" "), (item.status == 4 && _vm.type == 1) ? _c('td', {
      staticClass: "detail"
    }, [_c('a', {
      staticClass: "t-btn",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.toNewPageOne(item)
        }
      }
    }, [_vm._v("查看详情")])]) : _c('td', {
      staticClass: "detail"
    }, [_c('a', {
      staticClass: "t-btn",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.toNewPage(item)
        }
      }
    }, [_vm._v("查看详情")])])])
  })], 2)]), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "p-l"
  }, [_c('p', {
    staticClass: "total"
  }, [_vm._v("共" + _vm._s(_vm.page.total_count) + "条记录," + _vm._s(_vm.page.total_page) + "页,每页" + _vm._s(_vm.page.page_size) + "条记录")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.page.page_current,
      "page-size": _vm.page.page_size,
      "layout": "prev, pager, next",
      "total": _vm.page.total_count,
      "prev-text": "上一页",
      "next-text": "下一页"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39900bfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/recordlist/recordlist.vue
// module id = 625
// module chunks = 31